import React, { useEffect, useState } from "react";
import axios from "axios";
// //import AdminNav from "../components/adminNav";x
import { Link, useNavigate } from "react-router-dom"; // Use useNavigate

const Temp = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate(); // Initialize useNavigate

  // Fetch data from Node.js API
  useEffect(() => {
    axios
      .get("https://nissi-india.com/data")
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("branch");

    navigate("/login"); // Corrected logout navigation
  };

  return (
    <div id="admin-container">
     
      <div className="content-right">
        <section>
          <h2 className="add-txt">Own Vehicle Registration</h2>
          <div>
            <Link to="/home">
              <button className="home-btn">Home</button>
            </Link>
            <button onClick={handleLogout} className="logout">Logout</button> {/* Fixed onClick event */}
          </div>
        </section>
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Id</th>
                <th>Vehicle Code</th>
                <th>Vehicle Name</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.fld_masid}</td>
                    <td>{item.fld_vehiclecode}</td>
                    <td>{item.fld_vehiclename}</td>
                    <td>
                      <Link to={`/details/${item.id}`}>Details</Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">Loading</td> {/* Fixed colspan value */}
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Temp;

